function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}><g fill="none" fillRule="evenodd"><circle cx="10" cy="10" r="9" fill="#FFF" /><path fill="#42444C" fillRule="nonzero" d="M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-1.818a8.182 8.182 0 1 0 0-16.364 8.182 8.182 0 0 0 0 16.364z" /><rect width="2" height="10" x="9" y="5" fill="#42444C" rx="1" /><rect width="2" height="10" x="9" y="5" fill="#42444C" rx="1" transform="rotate(90 10 10)" /></g></svg>;
});